const Data = {
  support: [
    {
      name: "About Us",
      path: "/"
    },
    {
      name: "Contact Us",
      path: "/"
    },
  ],
  shop: [
    {
      name: "My account",
      path: "/"
    },
  ],
  company: [
    {
      name: "Shipping & Returns",
      path: "#"
    },
    {
      name: "Privacy Policy",
      path: "#"
    },
    {
      name: "Terms & Conditions",
      path: "#"
    },
  ],
  contact: [
    {
      name: "Customer Care",
    },
    {
      name: "Contact Support Available",
    },
    {
      name: "Mon To Sat : 10:00 Am to 6:00 Pm",
    },
    {
      name: "E-mail",
    },
    {
      name: "uboricllp@gmail.com",
    },
    {
      name: "Mobile",
    },
    {
      name: "+91 97243 82162",
    },
    {
      name: "+91 82000 99386",
    },
  ]
};

export default Data;
